import { CarnivalTreasureTotalBet } from '@/models/games/carnivalTreasure';
import { CMDScTotalBetCarnivaltreasure, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';
import { totalBetsSliceActions } from '@/modules/totalBet/slice';
import { AnyAction, Dispatch } from 'redux';

export class CMDScTotalBetCarnivaltreasureHandler extends AbstractHandler {
    _command: CMDScTotalBetCarnivaltreasure;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDScTotalBetCarnivaltreasure;
    }
    override handle(dispatch: Dispatch<AnyAction>): void {
        const TotalBet = {} as CarnivalTreasureTotalBet;
        const HostId = this._command.Total.HostID;
        let totalPlayerCount = 0;
        TotalBet.Main1 = this.convertBetAmount(this._command.Main1);
        TotalBet.Main2 = this.convertBetAmount(this._command.Main2);
        TotalBet.Main4 = this.convertBetAmount(this._command.Main4);
        TotalBet.Main7 = this.convertBetAmount(this._command.Main7);
        TotalBet.Main18 = this.convertBetAmount(this._command.Main18);
        TotalBet.Main40 = this.convertBetAmount(this._command.Main40);
        for (const ba of Object.values(TotalBet)) {
            totalPlayerCount += ba.BetPlayerCount;
        }
        TotalBet.Total = {
            Amount: this._command.Total.Amount,
            BetPlayerCount: totalPlayerCount,
        };
        dispatch(totalBetsSliceActions.update({ HostId, TotalBet }));
    }
}
